import { abortableFetchSSE } from '@loc/helpers/src/fetch/sse'

import type { TSseBaseEvent } from '@loc/helpers/src/fetch/sse'
import type { TCustomEvent } from '@loc/helpers/src/fetch/sse/extensions/abortable'

interface FetchParams {
  headers?: HeadersInit
  credentials?: RequestCredentials
  payload: any
  onEvent?: (event: TSseBaseEvent) => void
  onCustomEvent?: (event: TCustomEvent) => void
  onGeneratingError?: (errorCode: number, errorMessage: string) => void
  controller?: AbortController
}

class FetchStreamService {
  constructor(private url: string) {}
  public async fetchWithSSE({
    headers = {},
    credentials = 'include',
    payload,
    onEvent = (event) => {},
    onCustomEvent = (event) => {},
    onGeneratingError = (errorCode: number, errorMessage: string) => {},
    controller = new AbortController(),
  }: FetchParams) {
    try {
      await abortableFetchSSE(this.url, {
        headers,
        credentials,
        payload,
        signal: controller.signal,
        async onFetchResponse(response) {
          if (!response.ok) {
            const jsonData: { errorCode: number; errorMessage: string } =
              await response.json()
            onGeneratingError(jsonData.errorCode, jsonData.errorMessage)
          }
        },
        onEvent,
        onCustomEvent,
        onGeneratingError,
      })
    } catch (error) {
      onGeneratingError(500, (error as Error).message)
    }
  }
}

export default FetchStreamService
